// Static reference list of Munis workflow approval type codes, used by the
// workflow-processes page's approval-type search. Relocated here from the old
// shared/column-filters/filterOptions.js when that hardcoded filter-options
// fallback was removed.
export const wfApprovalTypes = [
  { value: "ACT", label: "Student Action Codes" },
  { value: "AMT", label: "Dollar Based" },
  { value: "APP", label: "Approver and Amt Based" },
  { value: "AUD", label: "System Auditing" },
  { value: "BDL", label: "Budget Level" },
  { value: "BTW", label: "Batch Total Waived Interest" },
  { value: "CAC", label: "Commodity and Change Amount" },
  { value: "CAT", label: "AR Category" },
  { value: "CCA", label: "Contingency and Amount" },
  { value: "CCC", label: "Contingency and Change Amount" },
  { value: "CE1", label: "PA Segment and Change Amt(Exp)" },
  { value: "CF1", label: "PA Segment and Change Amt(Fnd)" },
  { value: "CHG", label: "Charge Code" },
  { value: "CHK", label: "Checklist Tasks" },
  { value: "CMD", label: "Commodity Code (Detail)" },
  { value: "CMT", label: "Change Dollar Based" },
  { value: "COA", label: "Commodity and Amount" },
  { value: "COD", label: "AR Code" },
  { value: "COM", label: "Commodity Code" },
  { value: "CSA", label: "Segment and Change Amount" },
  { value: "CSH", label: "Available Cash" },
  { value: "DAY", label: "Days increased/decreased" },
  { value: "EOR", label: "Overall Rating" },
  { value: "ERT", label: "Evaluation Type" },
  { value: "ESC", label: "360 Source" },
  { value: "EST", label: "360 Source Type" },
  { value: "GLO", label: "G/L Org Code" },
  { value: "ITM", label: "Inventory Items" },
  { value: "JOB", label: "Job Class Code" },
  { value: "JOS", label: "Job Opening Status" },
  { value: "LOC", label: "Location Ranges" },
  { value: "NAI", label: "NAICS" },
  { value: "NOT", label: "Notification Only" },
  { value: "OVR", label: "Over Budget" },
  { value: "PAA", label: "Percent and Amount Based" },
  { value: "PAP", label: "Approver and Percentage Based" },
  { value: "PAT", label: "Project/Activity Type Code" },
  { value: "PCD", label: "Project Code" },
  { value: "PE1", label: "PA Segment and Amt (Expense)" },
  { value: "PE2", label: "PA Seg and Over Bud (Expense)" },
  { value: "PEC", label: "PA Change Amt (Expense)" },
  { value: "PEO", label: "PA Over Budget (Expense)" },
  { value: "PES", label: "PA Segment (Expense)" },
  { value: "PET", label: "PA Amount (Expense)" },
  { value: "PF1", label: "PA Segment and Amt (Funding)" },
  { value: "PFC", label: "PA Change Amt (Funding)" },
  { value: "PFS", label: "PA Segment (Funding)" },
  { value: "PFT", label: "PA Amount (Funding)" },
  { value: "RAD", label: "Refund Adjustment Type" },
  { value: "REF", label: "Refund Reason Code" },
  { value: "SEG", label: "General Ledger Segment" },
  { value: "SEO", label: "GL Segment and Over Budget" },
  { value: "SOA", label: "Segment and Amount" },
  { value: "TEM", label: "Template" },
  { value: "VEN", label: "Vendor based" },
  { value: "VER", label: "Verify Approval" },
  { value: "VIO", label: "Violation Code" },
  { value: "WAC", label: "WO Activity Codes" },
  { value: "WFG", label: "Work Flow Groups" },
]
